import {FC, useState} from "react";
import {Flex, Radio, RadioGroupProps} from "antd";
import {EventsTable} from "../../components/EventsTable/EventsTable.tsx";
import {EventFilter} from "../../types/domain.ts";
import {useEvents} from "../../queries/useEvents.ts";
import {useOwnProfile} from "../../stores/OwnProfileStore.ts";

export const ProcessingPage: FC = () => {
    const options: RadioGroupProps['options'] = [
        { label: 'Все', value: 'processing' },
        { label: 'Участник', value: 'processing_approver' },
        { label: 'Создатель', value: 'processing_creator' }
    ];

    const [value, setValue] = useState<EventFilter>('processing');
    const { data: events, isLoading, refetch } = useEvents(value);

    const { profile } = useOwnProfile();

    return (
        <Flex vertical gap={16} flex="1 0" style={{ width: '100%' }}>
            {profile?.role !== 'fir_reader' && (
                <Flex>
                    <Radio.Group
                        block
                        options={options}
                        value={value}
                        onChange={({ target }) => setValue(target.value)}
                        optionType="button"
                        buttonStyle="solid"
                        size="large"
                    />
                </Flex>
            )}
            <EventsTable
                events={events}
                loading={isLoading}
                onUpdate={refetch}
            />
        </Flex>
    );
}